import { useMediaQuery } from "@vueuse/core";

export function useIsScreenSmall() {
  const isScreenSmall = useMediaQuery("(max-width: 639px)");

  return { isScreenSmall };
}
